import "./styles.css";
import { useLocation } from "react-router-dom";
import SubmitWorkRequest from "./SubmitWorkRequest";
import ProcessWorkRequest from "./ProcessWorkRequest";

type TabOptions = 'process' | 'submit';

type LocationState = {
  tab?: TabOptions;
  myWorkRequest?: any;
};


const NewWorkRequestRedesign = ({ match, ...rest }: any)  => {
  const location = useLocation();
  const state = location.state as LocationState | undefined;

  const tabProcess = state && state.tab === 'process';

  return tabProcess ? <ProcessWorkRequest match={match} locationState={state} {...rest} /> : <SubmitWorkRequest match={match} locationState={state} {...rest} />
}
export default NewWorkRequestRedesign;